/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { MenuItem, Switch, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';

export default function EditAdminForm({
    firstName,
    lastName,
    login,
    userType,
    setFirstName,
    setLastName,
    setLogin,
    setUserType,
    language,
    setLanguage,firstNameError,setFirstNameError,lastNameError,setLastNameError,helperLoginText,setHelperLoginText
}: any): JSX.Element {
    const theme = useTheme();
    const md = useMediaQuery(theme.breakpoints.down('md'));
    const [helperText, setHelperText] = React.useState('')
    
    const { t } = useTranslation();

    React.useEffect(() => {
       
    }, [])

    const handleFirstNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFirstName(value);
        if (value.length > 24) {
            setFirstNameError(`${t('error_msg_24_character')}`);
        } else {
            setFirstNameError('');
        }
    };

    const handleLastNameChange=(e: React.ChangeEvent<HTMLInputElement>)=>{
        const value = e.target.value;
        setLastName(value);
        if (value.length > 24) {
            setLastNameError(`${t('error_msg_24_character')}`);
        }else{
            setLastNameError('');
        }
    };

    const isValidEmail = (email:string) => {
        const isValid = /\S+@\S+\.\S+/.test(email);
        return isValid
      }
    
    const handleLogin = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setLogin(e.target.value)
       if(!isValidEmail(e.target.value)){
        setHelperLoginText(`${t('msg_email_invalid')}`)
       }else if(e.target.value.length>24){
        setHelperLoginText(`${t('error_msg_24_character')}`)
        }
       else{
        setHelperLoginText('')
       }
       
    }


    const userTypes = [
        {
            code: 'ADMIN',
            value: 'Administrator',
        },
        {
            code: 'NORMAL_ADMIN',
            value: 'Normal Administrator',
        },
    ];

    const languages = [
        {
            code : 'en_US',
            value: 'English',
        },
        {
            code:'de_DE',
            value: 'Deutsch',
        },
        {
            code:'nl_NL',
            value: 'Nederlands',
        },
        {
            code:'fr_FR',
            value: 'Francais',
        },
        {
            code:'el_GR',
            value: 'Ἑλληνική',
        },
        {
            code:'it_IT',
            value: 'Italiano',
        },
        {
            code:'pt_PT',
            value: 'Portugues',
        },
    ];

    return (
        <Box
            sx={{
                flexGrow: 1,
                paddingTop: 3,
                paddingBottom: 5,
                paddingLeft: 3,
                paddingRight: 3,
                maxHeight:md?'75vh': 450,
                overflow: 'auto',
            }}
        >
            <Grid container spacing={3}>
                <Grid item xs={md?12:6}>
                    <TextField value={firstName} fullWidth id="filled-basic" label={t('lbl_firstName')} variant="filled" onChange={handleFirstNameChange} error={firstNameError.length > 0}  helperText={firstNameError}/>
                </Grid>
                <Grid item xs={md?12:6}>
                    <TextField value={lastName} fullWidth id="filled-basic" label={t('lbl_lastName')} variant="filled" onChange={handleLastNameChange} error={lastNameError.length>0} helperText={lastNameError}/>
                </Grid>
                <Grid item xs={12}>
                    <TextField value={login} fullWidth type={'email'} id="filled-basic" label={t('lbl_login')} variant="filled" error={helperLoginText.length > 0} helperText={helperLoginText} onChange={(e) => handleLogin(e)} />
                </Grid>
                <Grid item xs={12}>
                    <TextField select value={language} fullWidth id="filled-basic" label={'Select Language'} variant="filled" onChange={(e) => setLanguage(e.target.value)} >
                        {languages.map((user,i) => (
                            <MenuItem key={user.code} value={user.code}>
                                {user.value}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField select value={userType} fullWidth id="filled-basic" label={t('lbl_typeUsr')} variant="filled" onChange={(e) => setUserType(e.target.value)} >
                        {userTypes.map((user) => (
                            <MenuItem key={user.code} value={user.code}>
                                {user.value}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}></Grid>
            </Grid>
        </Box>
    );
}
